// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Select,
  Spinner
} from '../../'


class EmployerGroupSelect extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    employer: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    id: 'employerGroupSelect',
    placeholder: 'Select employer group'
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    if (this.props.data.error) {
      return <div>Options not loaded</div>
    }

    return (
      <Select
        id={this.props.id}
        default=' '
        placeholder={this.props.placeholder}
        value={this.props.value}
        options={this.props.data.employergroups.edges.map(employergroup => (
          {
            value: employergroup.node.id,
            label: employergroup.node.friendlyName
          }
        ))}
        onChange={this.props.onChange}
        hasError={this.props.hasError}
        className={this.props.className}
      />
    )
  }
}

const getEmployerGroup = gql`
  query {
    employergroups {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`

const withData = graphql(getEmployerGroup)

export default withData(EmployerGroupSelect)



// WEBPACK FOOTER //
// ./src/components/messageplus/employergroup-select/index.js